const validate = (values) => {
    const errors = {};
  
    if (!values.name) {
      errors.name = 'Please enter maitenance level name';
    }
    if (!values.collectionFrequencyId || !Number.isInteger(values.collectionFrequencyId)) {
      errors.collectionFrequencyId = 'Please select collection frequency';
    }
    return errors;
  };
  export default validate;
  


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/maintenanceLevel/validate.js